module.exports = "<p>\r\n  porcentaje-consulta works!\r\n</p>\r\n"